export default __webpack_public_path__ + "static/media/CG.8f3031ae.png";